
import { renderMessages } from './utils'

const WarnAlert = ({warnData, setWarnData}) => {
    return (
        <>
            {warnData !== null ? (
                renderMessages(warnData, setWarnData)
            ) : (
                <div />
            )}
        </>
    );
};


export default WarnAlert;